// |Math| Return a random number between two values.

function randomBetween (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default randomBetween;